import type { RefObject } from 'react';
import { useLayoutEffect, useState } from 'react';

export function useIsOverflowed(ref: RefObject<HTMLElement>) {
  const [isOverflowed, setIsOverflowed] = useState(false);

  useLayoutEffect(() => {
    const element = ref.current;

    if (!element) {
      return;
    }

    const checkOverflow = () => {
      setIsOverflowed(element.scrollWidth > element.clientWidth);
    };

    checkOverflow();

    const resizeObserver = new ResizeObserver(checkOverflow);
    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, [ref]);

  return isOverflowed;
}
